import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
   Button, ButtonToolbar, Modal, Alert,
} from 'reactstrap';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import parse from 'html-react-parser';

class TransactionDelete extends PureComponent {
   static propTypes = {
      modal: PropTypes.bool,
      toggle: PropTypes.func.isRequired,
      handleSubmit: PropTypes.func,
      errorMsg: PropTypes.string,
   };

   static defaultProps = {
      modal: false,
      handleSubmit: () => {
         console.log('submitted');
      },
      errorMsg: '',
   };

   constructor(props) {
      super(props);
      this.state = {};
      this.isLoading = false;
      this.toggle = this.toggle.bind(this);
   }

   toggle() {
      this.setState(prevState => ({ modal: !prevState.modal }));
   }

   render() {
      const {
         toggle, modal, handleSubmit, errorMsg,
      } = this.props;

      return (
         <div>
            <Modal
               isOpen={modal}
               className="modal-dialog--danger modal-dialog--header"
            >
               <div className="modal__header">
                  <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
                  <h4 className="bold-text  modal__title">Archive Transaction</h4>
               </div>
               <form onSubmit={handleSubmit} id="delete_transaction_form">
                  <div className="modal__body p-t-10">
                  { errorMsg && (
                     <div className="notif_msg">
                        <Alert color="danger" className="alert--colored">
                        <div className="alert__content">
                           <p>{ parse(errorMsg) }</p>
                        </div>
                        </Alert>
                     </div>
                     )
                  }
                  <div className="form form--vertical m-t-10">
                     <div className="form__form-group">
                        <span className="form__form-group-label">Archive Reason <b className="text-danger m-l-5">*</b>
                        </span>
                        <div className="form__form-group-field">
                           <textarea name="reason" className="no-resize mh-120" placeholder="Enter reason for removing transaction." />
                        </div>
                     </div>
                  </div>
                  </div>
                  <ButtonToolbar className="modal__footer">
                     <Button color="danger">Submit</Button>
                     <Button onClick={toggle}>Cancel</Button>
                  </ButtonToolbar>
               </form>
            </Modal>
         </div>
      );
   }
}

export default reduxForm({
  form: 'stockForm',
})(withTranslation('common')(TransactionDelete));
